// Match the native Pandectes reopen control to the German cookie-settings copy.
(() => {
  if (!document.documentElement.lang.toLowerCase().startsWith('de')) return;
  let root;
  const labelWidget = () => {
    const widget = root?.querySelector('button.widget[aria-haspopup="dialog"]');
    if (widget && widget.getAttribute('aria-label') !== 'Einwilligung ändern') {
      widget.setAttribute('aria-label', 'Einwilligung ändern');
    }
  };
  const widgetObserver = new MutationObserver(labelWidget);
  const connect = () => {
    const next = document.querySelector('pandectes-cmp')?.shadowRoot;
    if (!next) return false;
    if (root !== next) {
      widgetObserver.disconnect();
      root = next;
      widgetObserver.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-label'] });
    }
    labelWidget();
    return true;
  };
  if (connect()) return;
  const timer = window.setInterval(() => {
    if (connect()) window.clearInterval(timer);
  }, 250);
  window.setTimeout(() => window.clearInterval(timer), 20000);
})();
